import React from 'react';

function Home() {
  return (
    <div className="text-center">
      <h1>Home</h1>
      <h3>Welcome to the Graph Plotter application!</h3>
    </div>
  );
}

export default Home;
